// extracted by mini-css-extract-plugin
export default {"home":"About_home__FhVj4","manifesto":"About_manifesto__ZLnUu"};